Core.StaffLedgerRouter = Core.SubRouter.extend({
    routes: {

        '': 'staffLedger',
        'mine': 'mine',
        'all': 'all',
        'templates': 'templates',
        'user/:id': 'user',
        'customer/:id': 'customer',
        'customerproject/:id': 'customerProject',
        'order/:id': 'order',
        '*default': 'staffLedger'
    },

    staffLedger: function () {
        debug.log('staff ledger');
        var view = new StaffLedgerListView({scrolling: true});
        view.fetchList('all');
        app.setMainView(view, 'staffledger');
    },

    mine: function () {
        debug.log('mine');
        var view = new StaffLedgerListView({scrolling: true});
        view.selectList('mine');
        app.setMainView(view, 'staffledger');
    },

    all: function() {
        debug.log('all');
        var view = new StaffLedgerListView({scrolling: true});
        view.fetchList('all');
        app.setMainView(view, 'staffledger');
    },

    templates: function () {
        debug.log('templates');
        var view = new StaffLedgerListView({scrolling: true});
        view.fetchList('templates');
        app.setMainView(view, 'staffledger');
    },

    user: function(id) {
        debug.log('staff ledger user', id);
        var view = new StaffLedgerListView({scrolling: true});
        view.fetchList('user/'+id);
        app.setMainView(view, 'staffledger');
    },

    customer: function(id) {
        debug.log('staff ledger customer', id);
        var view = new StaffLedgerListView({scrolling: true});
        view.fetchList('customer/'+id);
        app.setMainView(view, 'staffledger');
    },

    customerProject: function(id) {
        debug.log('staff ledger customer project', id);
        var view = new StaffLedgerListView({scrolling: true});
        view.fetchList('customerProject/'+id);
        app.setMainView(view, 'staffledger');
    },

    order: function(id) {
        debug.log('staff ledger order', id);
        var view = new StaffLedgerListView({scrolling: true});
        view.fetchList('order/'+id);
        app.setMainView(view, 'staffledger');
    },
    
});
